import { PayloadAction } from '../types/payload-action';
import { BetaFeatureType } from '../types/beta-feature-type';
import { BetaTesterDto } from '../types/BetaTesterDto';

export const GET_BETA_TESTER = '[Wolverine] Get beta tester';
export const STORE_BETA_TESTER = '[Wolverine] Store beta tester';

export function getBetaTesterAction(
  data: BetaFeatureType
): PayloadAction<BetaFeatureType> {
  return {
    type: GET_BETA_TESTER,
    payload: data,
  };
}

export function storeBetaTesterAction(data: BetaTesterDto) {
  return {
    type: STORE_BETA_TESTER,
    payload: data,
  };
}



// WEBPACK FOOTER //
// ./ts/app/shared/actions/config.actions.ts